<template>
    <div class="crearOrden">
        <p id="user"></p>
        <vuestic-widget :header-text="'Crear Orden de Compra'">
            <form method="get" action="" name="crearCompra">
                    <div class="form-group">
                        <div class="input-group">
                            <label for="rutProveedor">
                                Rut Proveedor
                            </label>
                            <input type="text" id="rutProveedor" v-model="modelRutProveedor"
                                   required="required"/>
                            <i class="bar"/>
                        </div>
                        <div class="input-group">
                            <label for="nombre">Nombre Proveedor</label>
                            <input type="text" id="nombre" required="required">
                            <i class="bar"></i>
                        </div>
                        <div class="selects input-group">
                            <tipo/>
                            <i class="bar"></i>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="atencion input-group">
                            <label for="atencion_a">Atención A</label>
                            <input type="text" id="atencion_a" required="required"/>
                            <i class="bar"/>
                        </div>
                        <div class="selects input-group">
                            <condicion-pago/>
                            <i class="bar"></i>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group">
                            <label for="fecha">Fecha</label>
                            <input type="date" id="fecha" required="required"/>
                            <i class="bar"/>
                        </div>
                        <div class="input-group">
                            <label for="fechaRecepcion">Fecha Recepción</label>
                            <input type="date" id="fechaRecepcion" required="required"/>
                            <i class="bar"/>
                        </div>
                        <div class="selects input-group">
                            <transporte/>
                            <i class="bar"></i>
                        </div>
                    </div>
                    <tabla-detalle-crear/>
                    <tabla-pie/>
                    <div class="d-flex align--center justify--space-between">
                        <button class="btn btn-sm btn btn-info" type="submit">
                            Crear
                        </button>
                    </div>
            </form>
        </vuestic-widget>
    </div>
</template>
<script>
    import VuesticWidget from "../../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
    import Tipo from "../selectCompras/Tipo";
    import CondicionPago from "../selectCompras/CondicionPago";
    import Transporte from "../selectCompras/Transporte";
    import TablaDetalleCrear from "../Tablas/tablaDetalleCrear";
    import TablaPie from "../Tablas/tablaPie";
    export default {
      name: "CrearOrdenCompra",
      components: {TablaPie, TablaDetalleCrear, Transporte,
        CondicionPago, Tipo, VuesticWidget},
      data(){
        return{
          modelRutProveedor: ''
        }
      }
    }
</script>
<style scoped>
    .input-group{
        width: 15%;
        margin-right: 50px;
    }
    label{
        font-weight: bold;
    }
    .atencion.input-group{
        width: 33.5%;

    }
    .selects.input-group{
        width: 50%;
        margin-left: 50px;
        cursor: pointer;
    }
</style>
